import React, {useState} from 'react';
import "../../utils/Style/component/modals.scss";
import {Modal} from "react-bootstrap";
import { useDispatch } from "react-redux";
import { setActionType, setActionPayload } from "../../features/authorizationSlice"; 
import { ACTION_TYPES } from "../../app/actionTypes";
import usePayrollAdvanceApi from '../../api/PayrollAdvanceApi';

function DisableCashAdvancePopup({isOpen, setIsOpen, handleGoBack, handleClosePopups}) {
    const dispatch = useDispatch();
    
    const { DisableAllPayrollAdvance } = usePayrollAdvanceApi();
    

    const handleDisable = async () => {
        try {
            await DisableAllPayrollAdvance(); 
        } catch (error) {
            console.error(error);
        }
        finally {
            handleClosePopups(); 
        }
    };

    return (
        <div>
            <Modal centered show={isOpen} onHide={() => setIsOpen(false)} >
                <Modal.Body>
                <div className="mobile-confirmation-modal">
                        <div className="header">
                            <div className="modal-header-image">
                                <img src="/Images/caution.png" alt=""/>
                                <div>Are you sure you do not want to enable “Cash Advance” for next month?</div>
                            </div>
                        </div>
                            <div className="response-message confirmation-text">
                                <p className='text-popup'>The “cash advance” feature can be enabled only for specific employees</p>                         
                            </div>
                    </div>
                          

                    <div className='cash-buttons'>
                        <button id="closeTransferModalBtn" onClick={handleGoBack}>Cancel</button>
                        <button id="closeModalBtn" className='btn btn-success' onClick={handleDisable}>Not This Month</button>
                    </div>
                                    
                </Modal.Body>
            </Modal>

        </div>
    );
}

export default DisableCashAdvancePopup;
